import {
    GET_INSPECTION_STATUS_MASTER, GET_INSPECTION_STATUS_MASTER_ERROR, GET_ALL_MASTER_DATA,
    GET_ALL_MASTER_DATA_ERROR,
    GET_BLANK_DOCUMENTS_SEARCH,
    GET_BLANK_DOCUMENTS_SEARCH_ERROR, GET_ENGINEERING_MASTER, GET_ENGINEERING_MASTER_ERROR
    , GET_ALL_CURRENCY_TYPES, GET_ALL_CURRENCY_TYPES_ERROR,
    SET_FLAG, SET_FLAG_ERROR,
    GET_ALL_FILTERS,
    GET_ALL_FILTERS_ERROR,
    SEND_TEST_MAIL,
    SEND_TEST_MAIL_ERROR,
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_ERROR,
    GET_NOTIFICATIONS,
    GET_NOTIFICATIONS_ERROR,
    POST_CREATEUSER, POST_CREATEUSER_ERROR,
    GET_SIGNUP, GET_SIGNUP_ERROR,
    UPDATE_NOTIFICATION,
    UPDATE_NOTIFICATION_ERROR,
    PENDING_ACTIVITIES,
    PENDING_ACTIVITIES_ERROR,
} from '../type'
import axios from 'axios';
import env from '../../ENV';
import swal from '@sweetalert/with-react';
let ROOT_URL = env.BACKEND_URL;

export const getInspectionStatusMaster = () => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}status`)
        dispatch({
            type: GET_INSPECTION_STATUS_MASTER,
            payload: res.data
        })
        console.log(res.data)
    }
    catch (e) {
        dispatch({
            type: GET_INSPECTION_STATUS_MASTER_ERROR,
            payload: console.log(e),
        })
    }
}

export const getallMasterData = () => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}master-data`)
        dispatch({
            type: GET_ALL_MASTER_DATA,
            payload: res.data
        })
        // console.log(res.data)
    }
    catch (e) {
        dispatch({
            type: GET_ALL_MASTER_DATA_ERROR,
            payload: console.log(e),
        })
    }
}

export const getBlankDocumentsSearch = (data) => async dispatch => {

    console.log("recieved in store ", data)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/getAllSearchedBlankDocuments`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_BLANK_DOCUMENTS_SEARCH,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_BLANK_DOCUMENTS_SEARCH_ERROR,
            payload: console.log(e),
        })
    }

}

export const getEngineeringMaster = (id) => async dispatch => {

    try {
        const res = await axios.get(`${ROOT_URL}getEngineeringMaster`)
        dispatch({
            type: GET_ENGINEERING_MASTER,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ENGINEERING_MASTER_ERROR,
            payload: console.log(e),
        })
    }

}

export const GetAllCurrencyDetails = () => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}get-all-currecy-types`)
        dispatch({
            type: GET_ALL_CURRENCY_TYPES,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_CURRENCY_TYPES_ERROR,
            payload: console.log(e),
        })
    }
}
export const SetFlag = (data) => async dispatch => {

    console.log("recieved in store ", data)
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/set-flag`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: SET_FLAG,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: SET_FLAG_ERROR,
            payload: console.log(e),
        })
    }

}
export const GetFilterList = () => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}get-filter-list`)
        dispatch({
            type: GET_ALL_FILTERS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_ALL_FILTERS_ERROR,
            payload: console.log(e),
        })
    }

}
export const ChangePassword = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}auth/change-password`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: CHANGE_PASSWORD,
            payload: res
        })
    }
    catch (e) {
        dispatch({
            type: CHANGE_PASSWORD_ERROR,
            payload: e.response,
        })
    }

}
export const SendTestMail = (data) => async dispatch => {
    try {
        const res = await axios.get(`${ROOT_URL}send-initial-password`)
        dispatch({
            type: SEND_TEST_MAIL,
            payload: res
        })
    }
    catch (e) {
        dispatch({
            type: SEND_TEST_MAIL_ERROR,
            payload: e.response,
        })
    }

}

export const getNotifications = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/get-notifications`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_NOTIFICATIONS,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_NOTIFICATIONS_ERROR,
            payload: console.log(e),
        })
    }

}
export const getsignup = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'get',
            url: `${ROOT_URL}/get-signup`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: GET_SIGNUP,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: GET_SIGNUP_ERROR,
            payload: console.log(e),
        })
    }

}

export const createUser = (data) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}CreateUser`,
            data: data,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: POST_CREATEUSER,
            payload: res.data
        })
        swal("User Created", { icon: "success" })
    }
    catch (e) {
        dispatch({
            type: POST_CREATEUSER_ERROR,
            payload: console.log(e),
        })
        swal("Email Id already exist", { icon: "error" })
    }

}
export const UpdateNotification = (UserId) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/update-notifications`,
            data: { UserId: UserId },
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: UPDATE_NOTIFICATION,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: UPDATE_NOTIFICATION_ERROR,
            payload: console.log(e),
        })
    }

}

export const getPendingActivities = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/pending-activities`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: PENDING_ACTIVITIES,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PENDING_ACTIVITIES_ERROR,
            payload: console.log(e),
        })
    }

}

export const postClosePendency = (params) => async dispatch => {
    try {
        const res = await axios({
            method: 'post',
            url: `${ROOT_URL}/post-close-activities`,
            data: params,
            headers: {
                'content-type': 'application/json',
            }
        })
        dispatch({
            type: PENDING_ACTIVITIES,
            payload: res.data
        })
    }
    catch (e) {
        dispatch({
            type: PENDING_ACTIVITIES_ERROR,
            payload: console.log(e),
        })
    }

}